{
  "actions": {
    "delete": "Șterge",
    "edit": "Editează"
  },
  "toast": {
    "saved": "Salvat"
  },
  "studentTab": {
    "tabLabel": "Dans irlandez"
  },
  "nav": {
    "overview": "Dans irlandez"
  },
  "passes": {
    "heading": "Treceri la competiții",
    "lede": "Dansuri trecute (stele) după tipul de dans și nivel.",
    "add": "Înregistrează trecere",
    "noConfig": "Configurează mai întâi tipurile de dans și nivelurile în Setări → Dans.",
    "addTitle": "Înregistrează trecere la competiție",
    "editTitle": "Editează trecerea la competiție",
    "danceType": "Tip de dans",
    "level": "Nivel",
    "competition": "Numele competiției",
    "date": "Data competiției",
    "notes": "Note",
    "errTypeLevel": "Alege un tip de dans și un nivel.",
    "errCompetition": "Introdu numele competiției.",
    "errDate": "Alege o dată validă a competiției.",
    "confirmDelete": "Ștergi această trecere la competiție?",
    "noPasses": "Nicio trecere la competiție înregistrată încă."
  },
  "grades": {
    "heading": "Examene de grad",
    "lede": "Examene de grad numerotate (1–12) obținute.",
    "add": "Înregistrează grad",
    "empty": "Niciun examen de grad înregistrat încă.",
    "addTitle": "Înregistrează examen de grad",
    "editTitle": "Editează examenul de grad",
    "gradeNumber": "Grad",
    "examDate": "Data examenului",
    "location": "Locația examenului",
    "notes": "Note",
    "errDate": "Alege o dată validă a examenului.",
    "confirmDelete": "Ștergi gradul {n}?",
    "diplomaUploaded": "Diplomă încărcată.",
    "confirmRemoveDiploma": "Elimini scanarea diplomei?",
    "colGrade": "Grad",
    "colDate": "Data examenului",
    "colLocation": "Locație",
    "colDiploma": "Diplomă",
    "download": "Descarcă",
    "gradeN": "Gradul {n}",
    "uploadDiploma": "Încarcă diploma",
    "replaceDiploma": "Înlocuiește diploma",
    "removeDiploma": "Elimină diploma",
    "chooseFile": "Alege fișier…",
    "noFile": "Niciun fișier selectat",
    "currentAttached": "O scanare este deja atașată",
    "fileHint": "PDF sau imagine, max 25 MB"
  },
  "portal": {
    "title": "Progres dans irlandez",
    "passesHeading": "Treceri la competiții",
    "gradesHeading": "Examene de grad",
    "noPasses": "Nicio trecere la competiții încă.",
    "noGrades": "Niciun examen de grad încă."
  },
  "overview": {
    "title": "Dans irlandez — privire de ansamblu treceri",
    "sub": "Treceri la competiții pentru toți elevii.",
    "danceType": "Tip de dans",
    "level": "Nivel",
    "allDanceTypes": "Toate tipurile de dans",
    "allLevels": "Toate nivelurile",
    "colStudent": "Elev",
    "colDanceType": "Tip de dans",
    "colLevel": "Nivel",
    "colCompetition": "Competiție",
    "colDate": "Data",
    "empty": "Nicio trecere nu corespunde acestor filtre."
  }
}
